/* ── Dotted Earth Globe ── */
/* Pre-computed at module level — no re-renders, deterministic output */

const LAND: [number, number, number, number][] = [
  // North America
  [50, 85, -170, -55], [25, 50, -130, -65], [15, 32, -118, -86], [7, 18, -92, -77],
  // Greenland
  [60, 84, -58, -12],
  // South America
  [-5, 13, -82, -34], [-24, -5, -78, -34], [-40, -24, -72, -48], [-56, -40, -76, -62],
  // Europe
  [36, 71, -10, 42], [55, 71, 8, 32], [50, 60, -11, 2], [63, 67, -25, -13],
  // Africa
  [20, 37, -17, 35], [4, 20, -17, 48], [-5, 4, 8, 42], [-35, -5, 15, 52],
  // Middle East
  [12, 42, 32, 63],
  // Russia / Central Asia
  [50, 75, 40, 180], [35, 55, 50, 90],
  // China, Mongolia, Korea, Japan
  [20, 55, 75, 135], [30, 46, 128, 146],
  // India & South Asia
  [8, 35, 68, 90],
  // SE Asia & Indonesia
  [5, 28, 92, 110], [-8, 20, 95, 145],
  // Australia & NZ
  [-40, -11, 113, 155], [-47, -34, 165, 179],
];

function isLand(lat: number, lng: number) {
  return LAND.some(([a, b, c, d]) => lat >= a && lat <= b && lng >= c && lng <= d);
}

const GLOBE_DOTS: { x: number; y: number; opacity: number; size: number }[] = [];
const R = 230;
const ROWS = 50;
for (let i = 0; i < ROWS; i++) {
  const lat = -85 + i * (170 / (ROWS - 1));
  const latRad = (lat * Math.PI) / 180;
  const count = Math.max(8, Math.round(60 * Math.abs(Math.cos(latRad))));
  for (let j = 0; j < count; j++) {
    const lng = -180 + (j / count) * 360;
    if (!isLand(lat, lng)) continue;
    const vLng = ((lng + 20 + 540) % 360) - 180;
    const vRad = (vLng * Math.PI) / 180;
    const z = Math.cos(latRad) * Math.cos(vRad);
    if (z < -0.05) continue;
    GLOBE_DOTS.push({
      x: Math.round((250 + R * Math.cos(latRad) * Math.sin(vRad)) * 100) / 100,
      y: Math.round((250 - R * Math.sin(latRad)) * 100) / 100,
      opacity: Math.round(Math.max(0.06, 0.06 + z * 0.28) * 100) / 100,
      size: Math.round(Math.max(0.6, 0.8 + z * 1.4) * 100) / 100,
    });
  }
}

export default function DotGlobe() {
  return (
    <div
      className="absolute right-[-18%] sm:right-[-10%] lg:right-[-6%] top-1/2 -translate-y-1/2 w-[460px] h-[460px] sm:w-[560px] sm:h-[560px] lg:w-[660px] lg:h-[660px] pointer-events-none"
      aria-hidden="true"
    >
      <svg viewBox="0 0 500 500" fill="none" className="w-full h-full">
        <circle cx="250" cy="250" r="232" stroke="rgba(255,255,255,0.06)" strokeWidth="0.5" />
        {GLOBE_DOTS.map((d, i) => (
          <circle
            key={i}
            cx={d.x}
            cy={d.y}
            r={d.size}
            fill={`rgba(255,255,255,${d.opacity.toFixed(2)})`}
          />
        ))}
      </svg>
    </div>
  );
}
